/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Fold Less.
 * @export
 */
export const ICON_FOLD_LESS = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.11989 19.2997C8.50989 19.6897 9.13989 19.6897 9.52989 19.2997L11.9999 16.8297L14.4699 19.2997C14.8599 19.6897 15.4899 19.6897 15.8799 19.2997C16.2699 18.9097 16.2699 18.2797 15.8799 17.8897L12.7099 14.7197C12.3199 14.3297 11.6899 14.3297 11.2999 14.7197L8.12989 17.8897C7.72989 18.2697 7.72989 18.9097 8.11989 19.2997ZM15.8799 4.69973C15.4899 4.30973 14.8599 4.30973 14.4699 4.69973L11.9999 7.16973L9.52989 4.69973C9.13989 4.30973 8.50989 4.30973 8.11989 4.69973C7.72989 5.08973 7.72989 5.72973 8.11989 6.11973L11.2899 9.28973C11.6799 9.67973 12.3099 9.67973 12.6999 9.28973L15.8699 6.11973C16.2699 5.72973 16.2699 5.08973 15.8799 4.69973Z"
      fill="#3D3D3D"
    />
  </svg>
);
